export default class ValidationUtils {
	static isValidEmail = (email: string): boolean => {
		const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return emailRegex.test(email);
	}

	static isValidUrl = (url: string): boolean => {
		const urlRegex = /^http(s)?:\/\/(www\.)?.+[.].+$/;
		return urlRegex.test(url);
	}

	static isGoogleAnalyticsUaCode = (value: string): boolean => {
		const uaCodeRegex = /^UA-\d{4,10}-\d{1,4}$|^G-[A-Z0-9]+$/;
		return uaCodeRegex.test(value);
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/validation.ts